export default __webpack_public_path__ + "static/media/shareBlack.b6c69905.svg";